import { getUsersOfCategory } from "@/services/pricing-config.service";
import { useQuery } from "@tanstack/react-query";

export const useUsersOfCategory = (
  id,
  enabled = true,
  params = { page: 0, size: 10, search: "" },
  options = {},
) => {
  return useQuery({
    queryKey: [
      "users-of-category",
      id,
      params.page,
      params.size,
      params.search,
    ],

    queryFn: () => getUsersOfCategory(id, params),

    enabled: enabled && !!id,

    ...options,
  });
};
